import React from 'react'
import { useTranslation } from "react-i18next";
import { Grid, SvgIcon } from '@material-ui/core';

export const ForgotPasswordHeading = (props) => {
    const { t, ready } = useTranslation();

    if (!ready) {
        return null;
    }

    return <Grid item xs={12} container spacing={1}>
        <Grid item xs={12} className='loginForm-heading'>
            <button onClick={props.handleBack} className='loginForm-arrowBackBtn' aria-label='Back'>
                <i className="fas fa-solid fa-arrow-left"></i>
            </button>
            <h2>{t("loginView.forgotPasswordFormTitle")}</h2>
        </Grid>
        <Grid item xs={12}>

            <p className='loginForm-description'>{t("loginView.labelForgotPasswordTextTheInstructiosWillBeSend")}</p>
        </Grid>
    </Grid>
}

function ForgotPasswordForm(props) {
    const { t, ready } = useTranslation();

    if (!ready) {
        return null;
    }

    return (
        <Grid item xs={12} container className='loginForm-container'>
            {/* EMAIL FIELD */}
            <Grid item xs={12} className="loginForm-input-container">
                <label htmlFor="resetEmail" className="loginForm-input-label">{t("loginView.placeholderEmail")}</label>
                <div className='loginForm-input-wrapper'>
                    <input
                        type="text"
                        className="loginForm-input-field"
                        id="resetEmail"
                        onChange={(e) => props.onHandleGeneralChange(e)}
                        onKeyDown={(e) =>
                            props.onHandleResetPasswordKeypress(e)
                        }
                    />
                </div>
            </Grid>

            {/* ACTIONS */}
            <Grid item xs={12}>
                <button
                    className="loginForm-primaryBtn"
                    onClick={(e) => props.onHandleResetPassword(e)}
                >
                    {props.loading
                        ? <span className="preloader"></span>
                        : t("loginView.buttonSendEmail")
                    }
                </button>
            </Grid>
        </Grid>
    )
}

export default ForgotPasswordForm